import { RefObject, useCallback, useState } from 'react'
import { MeasureOnSuccessCallback, StyleProp, View, ViewStyle } from 'react-native'

interface ResolveValue {
    width: number
    pageX: number
}

export const usePaperTriangleIconPositioning = (
    anchorRef: RefObject<View | null>,
    listRef: RefObject<View | null>
): [StyleProp<ViewStyle> | undefined, () => void] => {
    const [position, setPosition] = useState<StyleProp<ViewStyle>>()

    const calculatePosition = useCallback(async () => {
        const getMeasureCallback =
            (resolve: (value: ResolveValue) => void): MeasureOnSuccessCallback =>
            (_, _1, width, _2, pageX) =>
                resolve({ width, pageX })

        const [anchor, container] = await Promise.all<ResolveValue>([
            new Promise((resolve) => anchorRef.current?.measure(getMeasureCallback(resolve))),
            new Promise((resolve) => listRef.current?.measure(getMeasureCallback(resolve))),
        ])

        setPosition({
            position: 'absolute',
            top: -9,
            left: anchor.pageX - container.pageX + anchor.width / 4,
        })
    }, [anchorRef, listRef])

    return [position, calculatePosition]
}
